import { Slider as SliderMaterial } from '@material-ui/core';
import React from 'react';
import ValueLabel from './components/ValueLabel';
var Slider = function (_a) {
    var className = _a.className, getAriaValueText = _a.getAriaValueText, marks = _a.marks, onChange = _a.onChange, defaultValue = _a.defaultValue, step = _a.step, min = _a.min, max = _a.max;
    return (React.createElement(SliderMaterial, { className: className, defaultValue: defaultValue, getAriaValueText: getAriaValueText, "aria-labelledby": "discrete-slider-custom", step: step, min: min, max: max, valueLabelDisplay: "off", ValueLabelComponent: ValueLabel, marks: marks, onChangeCommitted: onChange }));
};
Slider.defaultProps = {
    className: '',
    getAriaValueText: function () { return ''; },
    marks: '',
    onChange: function () { },
    defaultValue: 0,
    step: null,
    min: 0,
    max: 0,
};
export default Slider;
